// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  width: 100%;
  height: 100vh;
  background-color: #982D67;
  position: sticky;
  bottom: 0;
  top: 0;
  z-index: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}
.footer.visible {
  z-index: 1;
}
.footer .footer-container {
  width: calc(100% - 160px);
  height: calc(65% - 72px);
  padding-top: 72px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .footer .footer-container {
    width: calc(100% - 200px);
    height: calc(65% - 120px);
    padding-top: 120px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container {
    width: calc(100% - 80px);
    height: calc(65% - 112px);
    padding-top: 112px;
  }
}
@media (max-width: 750px) {
  .footer .footer-container {
    position: relative;
  }
}
@media (max-width: 550px) {
  .footer .footer-container {
    width: calc(100% - 32px);
    height: calc(75% - 32px);
    padding-top: 32px;
  }
}
.footer .footer-container .footer-contact-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p1 {
  width: 130px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 {
    width: 180px;
  }
}
@media (max-width: 750px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 {
    position: absolute;
    top: 112px;
    right: 0;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 {
    width: 100px;
    top: 32px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-image {
  width: 100%;
  height: 65px;
  position: relative;
  overflow: hidden;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-image {
    height: 90px;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-image {
    height: 50px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-image img {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: rotatingStar 12s linear infinite;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text {
  width: 100%;
  position: relative;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  color: #FFFFFF;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text {
    font-family: FixelDisplay;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text {
    letter-spacing: 0.08px;
    font-family: FixelDisplay;
    font-size: 8px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text p {
  width: 104%;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text img {
  position: absolute;
  bottom: 4px;
  right: 12px;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text img {
    bottom: 7px;
    right: 17px;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p1 .footer-contact-box-p1-text img {
    display: none;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 {
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
@media (max-width: 750px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 {
    padding-top: 150px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-label {
  opacity: 0.5;
  margin-bottom: 56px;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-label {
    margin-bottom: 40px;
    letter-spacing: 0.16px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-label {
    margin-bottom: 32px;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-label {
    margin-bottom: 24px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb {
  cursor: pointer;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 56px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb {
    font-family: FixelDisplay;
    font-size: 72px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 1150px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb {
    font-family: FixelDisplay;
    font-size: 46px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb {
    font-family: FixelDisplay;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin,
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb {
    font-family: FixelDisplay;
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-email-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-lin-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-fb-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-email-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-lin-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-fb-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-email-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-lin-text,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-fb-text {
  pointer-events: none;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-email-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-lin-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-fb-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-email-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-lin-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-fb-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-email-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-lin-text.top .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-fb-text.top .char {
  transform: translateY(0%);
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-email-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-lin-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-fb-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-email-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-lin-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-fb-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-email-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-lin-text.bottom .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-fb-text.bottom .char {
  opacity: 0;
  transform: translateY(-100%);
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-email-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-lin-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-fb-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-email-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-lin-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-lin .footer-contact-box-p2-fb-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-email-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-lin-text .char,
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-fb .footer-contact-box-p2-fb-text .char {
  display: inline-block;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email {
  width: 760px;
  height: 56px;
  margin-bottom: 24px;
  position: relative;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email {
    width: 980px;
    height: 72px;
    margin-bottom: 20px;
  }
}
@media (max-width: 1150px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email {
    width: 630px;
    height: 48px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email {
    width: 463px;
    height: 34px;
    margin-bottom: 20px;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email {
    width: 342px;
    height: 25px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-email .footer-contact-box-p2-email-text {
  position: absolute;
  top: 0;
  left: 0;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block {
  gap: 56px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block {
    gap: 96px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block {
    gap: 24px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-lin {
  width: 254px;
  height: 56px;
  position: relative;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-lin {
    width: 326px;
    height: 72px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-lin {
    width: 157px;
    height: 34px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-lin {
    width: 116px;
    height: 25px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-lin .footer-contact-box-p2-lin-text {
  position: absolute;
  top: 0;
  left: 0;
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-fb {
  width: 297px;
  height: 56px;
  position: relative;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-fb {
    width: 387px;
    height: 72px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-fb {
    width: 183px;
    height: 34px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-fb {
    width: 131px;
    height: 25px;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-fb {
    width: 133px;
    height: 25px;
  }
}
.footer .footer-container .footer-contact-box .footer-contact-box-p2 .footer-contact-box-p2-socmedia-block .footer-contact-box-p2-fb .footer-contact-box-p2-fb-text {
  position: absolute;
  top: 0;
  left: 0;
}
.footer .footer-container .footer-info-box {
  width: 100%;
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.footer .footer-container .footer-info-box p {
  width: 131px;
  text-transform: uppercase;
  letter-spacing: 0.14px;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-info-box p {
    width: 294px;
    letter-spacing: unset;
    font-family: FixelDisplay;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
@media (max-width: 750px) {
  .footer .footer-container .footer-info-box p {
    position: absolute;
    top: 112px;
    left: 0;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-info-box p {
    width: 146px;
    top: 55px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }
}
.footer .footer-container .footer-info-box .footer-info-box-container {
  width: 760px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-info-box .footer-info-box-container {
    width: 968px;
  }
}
@media (max-width: 1150px) {
  .footer .footer-container .footer-info-box .footer-info-box-container {
    width: 630px;
  }
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-info-box .footer-info-box-container {
    width: 463px;
  }
}
@media (max-width: 750px) {
  .footer .footer-container .footer-info-box .footer-info-box-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner {
  letter-spacing: 0.14px;
  text-transform: uppercase;
  min-height: 72px;
  font-family: FixelDisplay;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
@media (min-width: 1620px) {
  .footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner {
    letter-spacing: 0.16px;
    font-family: FixelDisplay;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-info-box-lable {
  opacity: 0.5;
  margin-bottom: 20px;
}
@media (max-width: 1050px) {
  .footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-info-box-lable {
    margin-bottom: 24px;
  }
}
@media (max-width: 550px) {
  .footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-info-box-lable {
    margin-bottom: 20px;
  }
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner img {
  cursor: pointer;
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-dev-link {
  position: relative;
  width: 58px;
  height: 32px;
  cursor: pointer;
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-dev-link .footer-dev-link-text {
  position: absolute;
  left: 0;
  top: 0;
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-dev-link .footer-dev-link-text.top .char {
  transform: translateY(0%);
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-dev-link .footer-dev-link-text.bottom .char {
  opacity: 0;
  transform: translateY(-100%);
}
.footer .footer-container .footer-info-box .footer-info-box-container .footer-info-box-container-inner .footer-dev-link .footer-dev-link-text .char {
  display: inline-block;
}
.footer .footer-title {
  width: 100%;
  position: absolute;
  bottom: -7px;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.footer .footer-title .footer-title-container img {
  width: 100%;
}
.footer .footer-title .footer-title-container.p1 {
  width: 31.5%;
}
.footer .footer-title .footer-title-container.p2 {
  width: 16.5%;
  position: relative;
}
.footer .footer-title .footer-title-container.p2 .footer-button-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.footer .footer-title .footer-title-container.p2 .footer-button {
  width: 72px;
  height: 72px;
  border-radius: 64px;
  background-color: #FFFFFF;
  color: #812456;
  position: relative;
  transition: color 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1050px) {
  .footer .footer-title .footer-title-container.p2 .footer-button {
    width: 56px;
    height: 56px;
  }
}
@media (max-width: 550px) {
  .footer .footer-title .footer-title-container.p2 .footer-button {
    width: 40px;
    height: 40px;
  }
}
.footer .footer-title .footer-title-container.p2 .footer-button svg {
  position: relative;
  z-index: 2;
}
.footer .footer-title .footer-title-container.p2 .footer-button::before {
  content: "";
  width: 74px;
  height: 74px;
  border-radius: 64px;
  background-color: #812456;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease-in-out;
  transform-origin: center;
}
.footer .footer-title .footer-title-container.p2 .footer-button:hover {
  color: #FFFFFF;
}
.footer .footer-title .footer-title-container.p2 .footer-button:hover::before {
  transform: translate(-50%, -50%) scale(1);
}
.footer .footer-title .footer-title-container.p3 {
  width: 50%;
}

@keyframes rotatingCircle {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,aAAA;EACA,yBCJS;EDKT,gBAAA;EACA,SAAA;EACA,MAAA;EAEA,UAAA;EEVA,aAAA;EACA,mBFUqB;EETrB,uBFS0B;EER1B,uBFQkC;AAAtC;AAEI;EACI,UAAA;AAAR;AAGI;EACI,yBAAA;EACA,wBAAA;EACA,iBAAA;EEpBJ,aAAA;EACA,sBFoByB;EEnBzB,8BFmBiC;EElBjC,uBFkBgD;AAEpD;AAAQ;EANJ;IAOQ,yBAAA;IACA,yBAAA;IACA,kBAAA;EAGV;AACF;AADQ;EAZJ;IAaQ,wBAAA;IACA,yBAAA;IACA,kBAAA;EAIV;AACF;AAFQ;EAlBJ;IAmBQ,kBAAA;EAKV;AACF;AAHQ;EAtBJ;IAuBQ,wBAAA;IACA,wBAAA;IACA,iBAAA;EAMV;AACF;AAJQ;EACI,WAAA;EE9CR,aAAA;EACA,mBF8C6B;EE7C7B,8BF6CkC;EE5ClC,uBF4CiD;AASrD;AAPY;EACI,YAAA;EElDZ,aAAA;EACA,sBFkDiC;EEjDjC,2BFiDyC;EEhDzC,uBFgDqD;AAYzD;AAVgB;EAJJ;IAKQ,YAAA;EAalB;AACF;AAXgB;EARJ;IASQ,kBAAA;IACA,UAAA;IACA,QAAA;EAclB;AACF;AAZgB;EAdJ;IAeQ,YAAA;IACA,SAAA;EAelB;AACF;AAbgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAepB;AAboB;EANJ;IAOQ,YAAA;EAgBtB;AACF;AAdoB;EAVJ;IAWQ,YAAA;EAiBtB;AACF;AAfoB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,2CAAA;AAiBxB;AAbgB;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cC9FZ;ECKJ,yBF0FqC;EEzFrC,eFyFmD;EExFnD,kBFwFyD;EEvFzD,gBFuFiE;EEtFjE,iBFsFsE;AAmB1E;AAjBoB;EARJ;IEpFZ,yBF6FyC;IE5FzC,eF4FuD;IE3FvD,kBF2F6D;IE1F7D,gBF0FqE;IEzFrE,iBFyF0E;EAwB5E;AACF;AAtBoB;EAZJ;IAaQ,sBAAA;IEjGpB,yBFkGyC;IEjGzC,cFiGuD;IEhGvD,kBFgG4D;IE/F5D,gBF+FoE;IE9FpE,iBF8FyE;EA6B3E;AACF;AA3BoB;EACI,WAAA;AA6BxB;AA1BoB;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AA4BxB;AA1BwB;EALJ;IAMQ,WAAA;IACA,WAAA;EA6B1B;AACF;AA3BwB;EAVJ;IAWQ,aAAA;EA8B1B;AACF;AAzBY;EACI,cChIR;ECFJ,aAAA;EACA,sBFkIiC;EEjIjC,2BFiIyC;EEhIzC,uBFgIqD;AA8BzD;AA5BgB;EAJJ;IAKQ,kBAAA;EA+BlB;AACF;AA7BgB;EACI,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EEtIhB,yBFuIqC;EEtIrC,eFsImD;EErInD,kBFqIyD;EEpIzD,gBFoIiE;EEnIjE,iBFmIsE;AAmC1E;AAjCoB;EAPJ;IAQQ,mBAAA;IACA,sBAAA;IE3IpB,yBF4IyC;IE3IzC,eF2IuD;IE1IvD,kBF0I6D;IEzI7D,gBFyIqE;IExIrE,iBFwI0E;EAwC5E;AACF;AAtCoB;EAbJ;IAcQ,mBAAA;EAyCtB;AACF;AAvCoB;EAjBJ;IAkBQ,mBAAA;EA0CtB;AACF;AAvCgB;;;EAGI,eAAA;EACA,yBAAA;EE5JhB,yBF6JqC;EE5JrC,eF4JmD;EE3JnD,kBF2JyD;EE1JzD,gBF0JiE;EEzJjE,iBFyJsE;AA6C1E;AA3CoB;EAPJ;;;IExJZ,yBFgKyC;IE/JzC,eF+JuD;IE9JvD,kBF8J6D;IE7J7D,gBF6JqE;IE5JrE,iBF4J0E;EAoD5E;AACF;AAlDoB;EAXJ;;;IExJZ,yBFoKyC;IEnKzC,eFmKuD;IElKvD,kBFkK6D;IEjK7D,gBFiKqE;IEhKrE,iBFgK0E;EA2D5E;AACF;AAzDoB;EAfJ;;;IExJZ,yBFwKyC;IEvKzC,eFuKuD;IEtKvD,kBFsK6D;IErK7D,gBFqKqE;IEpKrE,iBFoK0E;EAkE5E;AACF;AAhEoB;EAnBJ;;;IExJZ,yBF4KyC;IE3KzC,eF2KuD;IE1KvD,kBF0K6D;IEzK7D,gBFyKqE;IExKrE,iBFwK0E;EAyE5E;AACF;AAvEoB;;;;;;;;;EAGI,oBAAA;AA+ExB;AA5E4B;;;;;;;;;EACI,yBAAA;AAsFhC;AAjF4B;;;;;;;;;EACI,UAAA;EACA,4BAAA;AA2FhC;AAvFwB;;;;;;;;;EACI,qBAAA;AAiG5B;AA5FgB;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA8FpB;AA5FoB;EANJ;IAOQ,YAAA;IACA,YAAA;IACA,mBAAA;EA+FtB;AACF;AA7FoB;EAZJ;IAaQ,YAAA;IACA,YAAA;EAgGtB;AACF;AA9FoB;EAjBJ;IAkBQ,YAAA;IACA,YAAA;IACA,mBAAA;EAiGtB;AACF;AA/FoB;EAvBJ;IAwBQ,YAAA;IACA,YAAA;EAkGtB;AACF;AA/FoB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AAiGxB;AA7FgB;EACI,SAAA;EEnPhB,aAAA;EACA,mBFmPqC;EElPrC,2BFkP0C;EEjP1C,mBFiPsD;AAkG1D;AAhGoB;EAJJ;IAKQ,SAAA;EAmGtB;AACF;AAjGoB;EARJ;IASQ,SAAA;EAoGtB;AACF;AAlGoB;EACI,YAAA;EACA,YAAA;EACA,kBAAA;AAoGxB;AAlGwB;EALJ;IAMQ,YAAA;IACA,YAAA;EAqG1B;AACF;AAnGwB;EAVJ;IAWQ,YAAA;IACA,YAAA;EAsG1B;AACF;AApGwB;EAfJ;IAgBQ,YAAA;IACA,YAAA;EAuG1B;AACF;AArGwB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AAuG5B;AAnGoB;EACI,YAAA;EACA,YAAA;EACA,kBAAA;AAqGxB;AAnGwB;EALJ;IAMQ,YAAA;IACA,YAAA;EAsG1B;AACF;AApGwB;EAVJ;IAWQ,YAAA;IACA,YAAA;EAuG1B;AACF;AArGwB;EAfJ;IAgBQ,YAAA;IACA,YAAA;EAwG1B;AACF;AAtGwB;EApBJ;IAqBQ,YAAA;IACA,YAAA;EAyG1B;AACF;AAvGwB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AAyG5B;AAlGQ;EACI,WAAA;EACA,cC5TJ;ECFJ,aAAA;EACA,mBF8T6B;EE7T7B,8BF6TkC;EE5TlC,qBF4TiD;AAuGrD;AArGY;EACI,YAAA;EACA,yBAAA;EACA,sBAAA;EE7TZ,yBF8TiC;EE7TjC,eF6T+C;EE5T/C,kBF4TqD;EE3TrD,gBF2T6D;EE1T7D,iBF0TkE;AA2GtE;AAzGgB;EANJ;IAOQ,YAAA;IACA,qBAAA;IElUhB,yBFmUqC;IElUrC,eFkUmD;IEjUnD,kBFiUyD;IEhUzD,gBFgUiE;IE/TjE,iBF+TsE;EAgHxE;AACF;AA9GgB;EAZJ;IAaQ,kBAAA;IACA,UAAA;IACA,OAAA;EAiHlB;AACF;AA/GgB;EAlBJ;IAmBQ,YAAA;IACA,SAAA;IE9UhB,yBF+UqC;IE9UrC,eF8UmD;IE7UnD,kBF6UyD;IE5UzD,gBF4UiE;IE3UjE,iBF2UsE;EAsHxE;AACF;AAnHY;EACI,YAAA;EE3VZ,aAAA;EACA,mBF2ViC;EE1VjC,8BF0VsC;EEzVtC,qBFyVqD;AAwHzD;AAtHgB;EAJJ;IAKQ,YAAA;EAyHlB;AACF;AAvHgB;EARJ;IASQ,YAAA;EA0HlB;AACF;AAxHgB;EAZJ;IAaQ,YAAA;EA2HlB;AACF;AAzHgB;EAhBJ;IAiBQ,WAAA;IE3WhB,aAAA;IACA,mBF2WqC;IE1WrC,8BF0W0C;IEzW1C,uBFyWyD;EA+H3D;AACF;AA7HgB;EACI,sBAAA;EACA,yBAAA;EACA,gBAAA;EE3WhB,yBF4WqC;EE3WrC,eF2WmD;EE1WnD,kBF0WyD;EEzWzD,gBFyWiE;EExWjE,iBFwWsE;EEnXtE,aAAA;EACA,sBFmXqC;EElXrC,2BFkX6C;EEjX7C,uBFiXyD;AAsI7D;AApIoB;EAPJ;IAQQ,sBAAA;IEhXpB,yBFiXyC;IEhXzC,eFgXuD;IE/WvD,kBF+W6D;IE9W7D,gBF8WqE;IE7WrE,iBF6W0E;EA2I5E;AACF;AAvIoB;EACI,YAAA;EACA,mBAAA;AAyIxB;AAvIwB;EAJJ;IAKQ,mBAAA;EA0I1B;AACF;AAxIwB;EARJ;IASQ,mBAAA;EA2I1B;AACF;AAxIoB;EACI,eAAA;AA0IxB;AAvIoB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAyIxB;AAvIwB;EACI,kBAAA;EACA,OAAA;EACA,MAAA;AAyI5B;AAtIgC;EACI,yBAAA;AAwIpC;AAnIgC;EACI,UAAA;EACA,4BAAA;AAqIpC;AAjI4B;EACI,qBAAA;AAmIhC;AA1HI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EEpbJ,aAAA;EACA,mBFobyB;EEnbzB,8BFmb8B;EElb9B,qBFkb6C;AA+HjD;AA3HY;EACI,WAAA;AA6HhB;AA1HY;EACI,YAAA;AA4HhB;AAzHY;EACI,YAAA;EACA,kBAAA;AA2HhB;AAxHgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EE3chB,aAAA;EACA,mBF2cqC;EE1crC,uBF0c0C;EEzc1C,mBFyckD;AA6HtD;AA1HgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBCjdZ;EDkdY,cChdX;EDidW,kBAAA;EACA,kCAAA;EACA,eAAA;EEvdhB,aAAA;EACA,mBFudqC;EEtdrC,uBFsd0C;EErd1C,mBFqdkD;AA+HtD;AA7HoB;EAXJ;IAYQ,WAAA;IACA,YAAA;EAgItB;AACF;AA9HoB;EAhBJ;IAiBQ,WAAA;IACA,YAAA;EAiItB;AACF;AA/HoB;EACI,kBAAA;EACA,UAAA;AAiIxB;AA9HoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBC1ef;ED2ee,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,sCAAA;EACA,wBAAA;AAgIxB;AA7HoB;EACI,cCtfhB;ADqnBR;AA3HgB;EACI,yCAAA;AA6HpB;AAzHY;EACI,UAAA;AA2HhB;;AAlHA;EACI;IACE,uBAAA;EAqHJ;EAnHE;IACE,yBAAA;EAqHJ;AACF","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.footer {\n    width: 100%;\n    height: 100vh;\n    background-color: $main-color;\n    position: sticky;\n    bottom: 0;\n    top: 0;\n    // margin-top: -100vh;\n    z-index: 0;\n    @include mixins.flex(row, center, flex-start);\n\n    &.visible {\n        z-index: 1;\n    }\n\n    .footer-container {\n        width: calc(100% - 160px);\n        height: calc(65% - 72px);\n        padding-top: 72px;\n        @include mixins.flex(column, space-between, flex-start);\n\n        @media (min-width: 1620px) {\n            width: calc(100% - 200px);\n            height: calc(65% - 120px);\n            padding-top: 120px;\n        }\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 80px);\n            height: calc(65% - 112px);\n            padding-top: 112px;\n        }\n\n        @media (max-width: 750px) {\n            position: relative;\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 32px);\n            height: calc(75% - 32px);\n            padding-top: 32px;\n        }\n\n        .footer-contact-box {\n            width: 100%;\n            @include mixins.flex(row, space-between, flex-start);\n\n            .footer-contact-box-p1 {\n                width: 130px;\n                @include mixins.flex(column, flex-start, flex-start);\n\n                @media (min-width: 1620px) {\n                    width: 180px;\n                }\n\n                @media (max-width: 750px) {\n                    position: absolute;\n                    top: 112px;\n                    right: 0;\n                }\n\n                @media (max-width: 550px) {\n                    width: 100px;\n                    top: 32px;\n                }\n\n                .footer-contact-box-p1-image {\n                    width: 100%;\n                    height: 65px;\n                    position: relative;\n                    overflow: hidden;\n\n                    @media (min-width: 1620px) {\n                        height: 90px;\n                    }\n\n                    @media (max-width: 550px) {\n                        height: 50px;\n                    }\n\n                    img {\n                        width: 100%;\n                        position: absolute;\n                        left: 0;\n                        top: 0;\n                        animation: rotatingStar 12s linear infinite;\n                    }\n                }\n\n                .footer-contact-box-p1-text {\n                    width: 100%;\n                    position: relative;\n                    letter-spacing: 0.14px;\n                    text-transform: uppercase;\n                    color: $white;\n                    @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                    @media (min-width: 1620px) {\n                        @include mixins.font(FixelDisplay, 20px, normal, 500, 110%);\n                    }\n\n                    @media (max-width: 550px) {\n                        letter-spacing: 0.08px;\n                        @include mixins.font(FixelDisplay, 8px, normal, 500, 130%);\n                    }\n\n                    p {\n                        width: 104%;\n                    }\n\n                    img {\n                        position: absolute;\n                        bottom: 4px;\n                        right: 12px;\n\n                        @media (min-width: 1620px) {\n                            bottom: 7px;\n                            right: 17px;\n                        }\n\n                        @media (max-width: 550px) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n\n            .footer-contact-box-p2 {\n                color: $white;\n                @include mixins.flex(column, flex-start, flex-start);\n\n                @media (max-width: 750px) {\n                    padding-top: 150px;\n                }\n\n                .footer-contact-box-p2-label {\n                    opacity: 0.5;\n                    margin-bottom: 56px;\n                    letter-spacing: 0.14px;\n                    text-transform: uppercase;\n                    @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                    @media (min-width: 1620px) {\n                        margin-bottom: 40px;\n                        letter-spacing: 0.16px;\n                        @include mixins.font(FixelDisplay, 16px, normal, 500, 110%);\n                    }\n\n                    @media (max-width: 1050px) {\n                        margin-bottom: 32px;\n                    }\n\n                    @media (max-width: 550px) {\n                        margin-bottom: 24px;\n                    }\n                }\n\n                .footer-contact-box-p2-email,\n                .footer-contact-box-p2-lin,\n                .footer-contact-box-p2-fb {\n                    cursor: pointer;\n                    text-transform: uppercase;\n                    @include mixins.font(FixelDisplay, 56px, normal, 500, 100%);\n\n                    @media (min-width: 1620px) {\n                        @include mixins.font(FixelDisplay, 72px, normal, 500, 100%);\n                    }\n\n                    @media (max-width: 1150px) {\n                        @include mixins.font(FixelDisplay, 46px, normal, 500, 100%);\n                    }\n\n                    @media (max-width: 1050px) {\n                        @include mixins.font(FixelDisplay, 34px, normal, 500, 100%);\n                    }\n\n                    @media (max-width: 550px) {\n                        @include mixins.font(FixelDisplay, 25px, normal, 500, 100%);\n                    }\n\n                    .footer-contact-box-p2-email-text,\n                    .footer-contact-box-p2-lin-text,\n                    .footer-contact-box-p2-fb-text {\n                        pointer-events: none;\n\n                        &.top {\n                            .char {\n                                transform: translateY(0%);\n                            }\n                        }\n                \n                        &.bottom {\n                            .char {\n                                opacity: 0;\n                                transform: translateY(-100%);\n                            }\n                        }\n                \n                        .char {\n                            display: inline-block;\n                        }\n                    }\n                }\n\n                .footer-contact-box-p2-email {\n                    width: 760px;\n                    height: 56px;\n                    margin-bottom: 24px;\n                    position: relative;\n\n                    @media (min-width: 1620px) {\n                        width: 980px;\n                        height: 72px;\n                        margin-bottom: 20px;\n                    }\n                    \n                    @media (max-width: 1150px) {\n                        width: 630px;\n                        height: 48px;\n                    }\n\n                    @media (max-width: 1050px) {\n                        width: 463px;\n                        height: 34px;\n                        margin-bottom: 20px;\n                    }\n\n                    @media (max-width: 550px) {\n                        width: 342px;\n                        height: 25px;\n                    }\n\n\n                    .footer-contact-box-p2-email-text {\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                    }\n                }\n\n                .footer-contact-box-p2-socmedia-block {\n                    gap: 56px;\n                    @include mixins.flex(row, flex-start, center);\n\n                    @media (min-width: 1620px) {\n                        gap: 96px;\n                    }\n\n                    @media (max-width: 1050px) {\n                        gap: 24px;\n                    }\n\n                    .footer-contact-box-p2-lin {\n                        width: 254px;\n                        height: 56px;\n                        position: relative;\n\n                        @media (min-width: 1620px) {\n                            width: 326px;\n                            height: 72px;\n                        }\n\n                        @media (max-width: 1050px) {\n                            width: 157px;\n                            height: 34px;\n                        }\n\n                        @media (max-width: 1050px) {\n                            width: 116px;\n                            height: 25px;\n                        }\n    \n                        .footer-contact-box-p2-lin-text {\n                            position: absolute;\n                            top: 0;\n                            left: 0;\n                        }\n                    }\n\n                    .footer-contact-box-p2-fb {\n                        width: 297px;\n                        height: 56px;\n                        position: relative;\n\n                        @media (min-width: 1620px) {\n                            width: 387px;\n                            height: 72px;\n                        }\n\n                        @media (max-width: 1050px) {\n                            width: 183px;\n                            height: 34px;\n                        }\n\n                        @media (max-width: 1050px) {\n                            width: 131px;\n                            height: 25px;\n                        }\n\n                        @media (max-width: 550px) {\n                            width: 133px;\n                            height: 25px;\n                        }\n    \n                        .footer-contact-box-p2-fb-text {\n                            position: absolute;\n                            top: 0;\n                            left: 0;\n                        }\n                    }\n                }\n            }\n        }\n\n        .footer-info-box {\n            width: 100%;\n            color: $white;\n            @include mixins.flex(row, space-between, flex-end);\n\n            p {\n                width: 131px;\n                text-transform: uppercase;\n                letter-spacing: 0.14px;\n                @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n\n                @media (min-width: 1620px) {\n                    width: 294px;\n                    letter-spacing: unset;\n                    @include mixins.font(FixelDisplay, 32px, normal, 600, 100%);\n                }\n\n                @media (max-width: 750px) {\n                    position: absolute;\n                    top: 112px;\n                    left: 0;\n                }\n\n                @media (max-width: 550px) {\n                    width: 146px;\n                    top: 55px;\n                    @include mixins.font(FixelDisplay, 16px, normal, 600, 100%);\n                }\n            }\n\n            .footer-info-box-container {\n                width: 760px;\n                @include mixins.flex(row, space-between, flex-end);\n\n                @media (min-width: 1620px) {\n                    width: 968px;\n                }\n\n                @media (max-width: 1150px) {\n                    width: 630px;\n                }\n\n                @media (max-width: 1050px) {\n                    width: 463px;\n                }\n\n                @media (max-width: 750px) {\n                    width: 100%;\n                    @include mixins.flex(row, space-between, flex-start);\n                }\n\n                .footer-info-box-container-inner {\n                    letter-spacing: 0.14px;\n                    text-transform: uppercase;\n                    min-height: 72px;\n                    @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n                    @include mixins.flex(column, flex-start, flex-start);\n\n                    @media (min-width: 1620px) {\n                        letter-spacing: 0.16px;\n                        @include mixins.font(FixelDisplay, 16px, normal, 500, 110%);\n                    }\n\n                    \n\n                    .footer-info-box-lable {\n                        opacity: 0.5;\n                        margin-bottom: 20px;\n\n                        @media (max-width: 1050px) {\n                            margin-bottom: 24px;\n                        }\n\n                        @media (max-width: 550px) {\n                            margin-bottom: 20px;\n                        }\n                    }\n\n                    img {\n                        cursor: pointer;\n                    }\n\n                    .footer-dev-link {\n                        position: relative;\n                        width: 58px;\n                        height: 32px;\n                        cursor: pointer;\n\n                        .footer-dev-link-text {\n                            position: absolute;\n                            left: 0;\n                            top: 0;\n\n                            &.top {\n                                .char {\n                                    transform: translateY(0%);\n                                }\n                            }\n                    \n                            &.bottom {\n                                .char {\n                                    opacity: 0;\n                                    transform: translateY(-100%);\n                                }\n                            }\n                    \n                            .char {\n                                display: inline-block;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .footer-title {\n        width: 100%;\n        position: absolute;\n        bottom: -7px;\n        left: 0;\n        @include mixins.flex(row, space-between, flex-end);\n\n        .footer-title-container {\n\n            img {\n                width: 100%;\n            }\n\n            &.p1 {\n                width: 31.5%;\n            }\n\n            &.p2 {\n                width: 16.5%;\n                position: relative;\n                \n\n                .footer-button-container {\n                    width: 100%;\n                    height: 100%;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    @include mixins.flex(row, center, center);\n                }\n\n                .footer-button {\n                    width: 72px;\n                    height: 72px;\n                    border-radius: 64px;\n                    background-color: $white;\n                    color: $purple;\n                    position: relative;\n                    transition: color 0.3s ease-in-out;\n                    cursor: pointer;\n                    @include mixins.flex(row, center, center);\n\n                    @media (max-width: 1050px) {\n                        width: 56px;\n                        height: 56px;\n                    }\n\n                    @media (max-width: 550px) {\n                        width: 40px;\n                        height: 40px;\n                    }\n\n                    svg {\n                        position: relative;\n                        z-index: 2;\n                    }\n\n                    &::before {\n                        content: '';\n                        width: 74px;\n                        height: 74px;\n                        border-radius: 64px;\n                        background-color: $purple;\n                        position: absolute;\n                        top: 50%;\n                        left: 50%;\n                        transform: translate(-50%, -50%) scale(0);\n                        transition: transform 0.3s ease-in-out;\n                        transform-origin: center;\n                    }\n    \n                    &:hover {\n                        color: $white;\n                    }\n                }\n\n                .footer-button:hover::before {\n                    transform: translate(-50%, -50%) scale(1);\n                }\n            }\n\n            &.p3 {\n                width: 50%;\n            }\n        }\n    }\n}\n\n\n// Stars Rotating Animation\n\n@keyframes rotatingCircle {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
